module.exports = __webpack_public_path__ + "toronto-universities.png?1f41473ff539fb08537542451091b608";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/toronto-universities.png
// module id = 146
// module chunks = 0